import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";
import { installNativeApiBridge } from "./native-api";
import { installRemoteNav } from "./lib/remote-nav";

// Packaged app only — a no-op in the browser. The iOS shell serves this SPA
// from capacitor://localhost, so /api/* must be pointed back at the Netlify
// origin before anything renders and starts fetching.
installNativeApiBridge();

// Arm D-pad navigation on TVs (webOS 22+, Tizen 2019+, box browsers) that can
// only run the web app. A no-op everywhere else: on a desktop the arrow keys
// belong to the player and the search field.
installRemoteNav();

// NOTE: deliberately NO <React.StrictMode>. StrictMode double-mounts every
// component in development; for EmbedPlayer that means the player <iframe> is
// created, boots the Vidking player, then gets detached — and a detached
// iframe keeps playing audio in Chrome. The user hears two positions at once
// (the "double audio" bug). The injected orphan-guard in playback-proxy.js
// also pauses detached frames as a second line of defense.
ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
